// Generated by purs version 0.15.15
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
var unsafeIndex = /* #__PURE__ */ Data_Array.unsafeIndex();
var decodeRecord1 = /* #__PURE__ */ Unscramble.decodeRecord1();
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Tuple.functorTuple);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorFn);
var fromFoldable = /* #__PURE__ */ Foreign_Object.fromFoldable(Data_Foldable.foldableArray);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var genericDecodeManyArgsArgu = function (dictDecode) {
    var unsafeDecode = Unscramble.unsafeDecode(dictDecode);
    return {
        argsDecoder: new Data_Tuple.Tuple(1, function (offset) {
            return function (array) {
                return unsafeDecode(unsafeIndex(array)(offset));
            };
        })
    };
};
var genericDecodeArgsNoArgume = {
    genericDecodeArgs: function (v) {
        return Data_Generic_Rep.NoArguments.value;
    }
};
var genericDecodeArgsArgument = function (dictDecode) {
    return {
        genericDecodeArgs: (function () {
            var $88 = Unscramble.unsafeDecode(dictDecode);
            return function ($89) {
                return Data_Generic_Rep.Argument($88($89));
            };
        })()
    };
};
var decodeSingleConstructorAr = function () {
    return function (dictDecodeRecord) {
        return {
            unsafeDecodeSingleConstructorArgument: Unscramble.unsafeDecode(decodeRecord1(dictDecodeRecord))
        };
    };
};
var unwrapContents = function ($90) {
    return $90.contents;
};
var decodeSingleConstructorAr1 = function (dictDecode) {
    return {
        unsafeDecodeSingleConstructorArgument: (function () {
            var $91 = Unscramble.unsafeDecode(dictDecode);
            return function ($92) {
                return $91(unwrapContents($92));
            };
        })()
    };
};
var unsafeDecodeSingleConstructorArgument = function (dict) {
    return dict.unsafeDecodeSingleConstructorArgument;
};
var genericDecodeSumConstruct = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    return function (dictDecodeSingleConstructorArgument) {
        var unsafeDecodeSingleConstructorArgument1 = unsafeDecodeSingleConstructorArgument(dictDecodeSingleConstructorArgument);
        return {
            genericSumDecoder: function (_opts) {
                return [ new Data_Tuple.Tuple(reflectSymbol(Type_Proxy["Proxy"].value), function ($93) {
                    return Data_Generic_Rep.Constructor(Data_Generic_Rep.Argument(unsafeDecodeSingleConstructorArgument1($93)));
                }) ];
            }
        };
    };
};
var genericSumDecoder = function (dict) {
    return dict.genericSumDecoder;
};
var genericDecodeSumSum = function (dictGenericDecodeSum) {
    var genericSumDecoder1 = genericSumDecoder(dictGenericDecodeSum);
    return function (dictGenericDecodeSum1) {
        var genericSumDecoder2 = genericSumDecoder(dictGenericDecodeSum1);
        return {
            genericSumDecoder: function (opts) {
                return append(map(map1(map2(Data_Generic_Rep.Inl.create)))(genericSumDecoder1(opts)))(map(map1(map2(Data_Generic_Rep.Inr.create)))(genericSumDecoder2(opts)));
            }
        };
    };
};
var genericDecoder = function (dict) {
    return dict.genericDecoder;
};
var genericUnsafeDecode = function (dictGeneric) {
    var to = Data_Generic_Rep.to(dictGeneric);
    return function (dictGenericDecode) {
        var genericDecoder1 = genericDecoder(dictGenericDecode);
        return function (opts) {
            var $94 = genericDecoder1(opts);
            return function ($95) {
                return to($94($95));
            };
        };
    };
};
var genericDecodeTaggedSumType = function (dictGenericDecodeSum) {
    var genericSumDecoder1 = genericSumDecoder(dictGenericDecodeSum);
    return function (opts) {
        var constructors = fromFoldable(genericSumDecoder1(opts));
        return function (value) {
            var tag = Unscramble.decodeString((Unscramble.expectObject(value)).tag);
            var v = Foreign_Object.lookup(tag)(constructors);
            if (v instanceof Data_Maybe.Nothing) {
                return Unscramble.decodingError("Invalid sum type tag: " + show(tag));
            };
            if (v instanceof Data_Maybe.Just) {
                return v.value0(value);
            };
            throw new Error("Failed pattern match at Unscramble.Generic (line 50, column 5 - line 54, column 22): " + [ v.constructor.name ]);
        };
    };
};
var genericUnsafeDecodeTagged = function (dictGeneric) {
    var to = Data_Generic_Rep.to(dictGeneric);
    return function (dictGenericDecodeSum) {
        var genericDecodeTaggedSumType1 = genericDecodeTaggedSumType(dictGenericDecodeSum);
        return function (opts) {
            var $96 = genericDecodeTaggedSumType1(opts);
            return function ($97) {
                return to($96($97));
            };
        };
    };
};
var genericDecode = function (dictGenericDecodeSum) {
    return {
        genericDecoder: genericDecodeTaggedSumType(dictGenericDecodeSum)
    };
};
var genericDecodeArgs = function (dict) {
    return dict.genericDecodeArgs;
};
var genericDecodeConstructor = function (dictGenericDecodeArgs) {
    var genericDecodeArgs2 = genericDecodeArgs(dictGenericDecodeArgs);
    return {
        genericDecoder: function (opts) {
            return function ($98) {
                return Data_Generic_Rep.Constructor(genericDecodeArgs2($98));
            };
        }
    };
};
var genericDecodeSumConstruct1 = function (dictGenericDecodeArgs) {
    var genericDecodeArgs2 = genericDecodeArgs(dictGenericDecodeArgs);
    return function (dictIsSymbol) {
        var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
        return {
            genericSumDecoder: function (_opts) {
                return [ new Data_Tuple.Tuple(reflectSymbol(Type_Proxy["Proxy"].value), function ($99) {
                    return Data_Generic_Rep.Constructor(genericDecodeArgs2(unwrapContents($99)));
                }) ];
            }
        };
    };
};
var defaultOptions = {};
var argsDecoder = function (dict) {
    return dict.argsDecoder;
};
var genericDecodeArgs1 = function (dictGenericDecodeManyArgs) {
    return {
        genericDecodeArgs: (function () {
            var v = argsDecoder(dictGenericDecodeManyArgs);
            return function (value) {
                var array = Unscramble.expectArray(value);
                var $79 = Data_Array.length(array) === v.value0;
                if ($79) {
                    return v.value1(0)(array);
                };
                return Unscramble.decodingError("Invalid number of constructor arguments");
            };
        })()
    };
};
var genericDecodeManyArgsProd = function (dictGenericDecodeManyArgs) {
    var argsDecoder1 = argsDecoder(dictGenericDecodeManyArgs);
    return function (dictGenericDecodeManyArgs1) {
        return {
            argsDecoder: (function () {
                var v1 = argsDecoder(dictGenericDecodeManyArgs1);
                return new Data_Tuple.Tuple(argsDecoder1.value0 + v1.value0 | 0, function (offset) {
                    return function (array) {
                        return new Data_Generic_Rep.Product(argsDecoder1.value1(offset)(array), v1.value1(offset + argsDecoder1.value0 | 0)(array));
                    };
                });
            })()
        };
    };
};
export {
    argsDecoder,
    genericDecodeArgs,
    genericDecoder,
    genericSumDecoder,
    unsafeDecodeSingleConstructorArgument,
    genericUnsafeDecode,
    genericUnsafeDecodeTagged,
    defaultOptions,
    genericDecodeTaggedSumType,
    unwrapContents,
    genericDecodeConstructor,
    genericDecode,
    decodeSingleConstructorAr,
    decodeSingleConstructorAr1,
    genericDecodeSumConstruct,
    genericDecodeSumConstruct1,
    genericDecodeArgsNoArgume,
    genericDecodeArgsArgument,
    genericDecodeArgs1,
    genericDecodeManyArgsProd,
    genericDecodeManyArgsArgu,
    genericDecodeSumSum
};
